import React from 'react';

export function PermissionsRequired(props){
  return <section>
    <h1>Permissions Required</h1>
    <h2>Your account does not have the required permissions to complete your request. Contact your instructor if you believe this is an error.</h2>
    </section>
}